/** User-facing contract review / new-version errors (mirrors server catalog). */

export const REVIEW_USER_ERROR = {
  insufficientPermissions: "Insufficient permissions",
  reviewNotFound: "Review not found",
  contractFileRequired: "Upload a contract file to continue.",
  selectFileToUpload: "Select a contract file to upload.",
  reviewIncomplete: "Review could not be completed. Please try again.",
  saveNewVersionFailed: "Could not save the new version. Please try again.",
  createNewVersionFailed: "Could not create the new version. Please try again.",
  generic: "Something went wrong. Please try again.",
} as const;

const LEGACY_AND_INTERNAL: Record<string, string> = {
  "A contract file is required": REVIEW_USER_ERROR.contractFileRequired,
  "Please select a file to upload.": REVIEW_USER_ERROR.selectFileToUpload,
  "Review workflow did not produce a valid report": REVIEW_USER_ERROR.reviewIncomplete,
  "Source review not found": REVIEW_USER_ERROR.reviewNotFound,
  "Failed to insert new review version": REVIEW_USER_ERROR.saveNewVersionFailed,
  "Failed to create new review version": REVIEW_USER_ERROR.saveNewVersionFailed,
  "Failed to save new review version": REVIEW_USER_ERROR.saveNewVersionFailed,
  "Internal server error": REVIEW_USER_ERROR.generic,
  "New version could not be completed. Check the server logs or try again.":
    REVIEW_USER_ERROR.createNewVersionFailed,
};

const PASSTHROUGH = new Set<string>(Object.values(REVIEW_USER_ERROR));

export function mapReviewUserError(message: string): string {
  const trimmed = message.trim();
  if (!trimmed) {
    return REVIEW_USER_ERROR.generic;
  }
  if (PASSTHROUGH.has(trimmed)) {
    return trimmed;
  }
  const mapped = LEGACY_AND_INTERNAL[trimmed];
  if (mapped) {
    return mapped;
  }
  return REVIEW_USER_ERROR.generic;
}
